import React from 'react'
import { useSnapshot } from 'valtio'
import { state } from '../../context/store'
import { productChoices } from '../../context/productChoices'
import { Button } from '../Blocks'
import { getKatanaSkew, capitalizeFirstLetter, calculatePrice } from '../../utilities'
import { custom } from '../../context/customisationSettings'

const PlaceOrderButton = ({ disabled = true }) => {
  const snap = useSnapshot(state.current)
  const productSnap = useSnapshot(productChoices.current)

  const currentProduct = productSnap.choices[snap.initialChoices.type.index]

  // console.log(currentProduct)

  const productId = snap.stagingIds ? currentProduct.testingId[0] : currentProduct.id[0]

  // console.log("Staging IDs:", snap.stagingIds)
  console.log(productId)

  const sku = getKatanaSkew()

  const finalPrice = calculatePrice(snap)

  //   // const text = await res.text()
  //   // console.log(text)

  //   return data.url // or data.id
  // }

  const blobUrlToDataURI = async (blobUrl) => {
    const res = await fetch(blobUrl)
    const blob = await res.blob()

    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(blob)
    })
  }

  const addToCart = async (productId, options = {}) => {
    if (!productId) {
      return
    }

    // const formData = new URLSearchParams()
    const formData = new FormData()
    formData.append('add-to-cart', String(productId))

    if (Object.keys(options).length > 0) {
      formData.append('custom_fields', JSON.stringify(options))
      console.log('Adding to cart with options:', options)
    }
    // console.log(productId);
    try {
      // // dont use this.
      // const responseOld = await fetch(`/?add-to-cart=${productId}`, {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded',
      //   },
      //   body: formData.toString(),
      // })

      // try this instead (formData object handles header)
      const response = await fetch(`/?add-to-cart=${productId}`, {
        method: 'POST',
        body: formData,
      })

      const text = await response.text()
      // console.log('WooCommerce response:', text)
    } catch (error) {
      // console.error('Failed to add to cart:', error)
    }

    state.current.status.productBeingAdded = false
    state.current.modal.orderSummary = false

    state.current.modal.orderConfirmed = true
    // console.log("------Added to Cart")
  }

  const customAddToCart = async () => {
    // console.log("------Adding to Cart")
    state.current.status.productBeingAdded = false
    state.current.status.cartContentNumber = state.current.status.cartContentNumber + 1
    const options = {
      id: productId,
      fields: {
        SKU: sku,
        customPrice: finalPrice.toFixed(2),
        Make: snap.initialChoices.make.name,
        Model: snap.initialChoices.model.name,
        Year: snap.initialChoices.year.name,
        sideColor: snap.choices.sidePanels.selected.name,
        topColor: snap.choices.topPanel.selected.name,
      },
    }

    if (snap.package === 'enjoy') {
      options.fields.topLogo = capitalizeFirstLetter(snap.choices.topLogo.selected.mode)
      if (snap.choices.sideLogos.selected.mode !== 'none') {
        options.fields.sideLogo = snap.choices.sideLogos.selected.name
      }
    }

    if (snap.choices.sidePanels.selected.mode === 'reinforced') {
      options.fields.reinforcedSides = 'Yes'
      options.fields.sideColor = snap.choices.sidePanels.selected.name
    }

    if (snap.choices.ribs.selected.mode === 'single') {
      options.fields.ribMode = 'Single Colored Ribs'
      options.fields.ribColor = capitalizeFirstLetter(
        snap.choices.ribs.selected.rib[0].name,
      )
    }
    if (snap.choices.ribs.selected.mode === 'multiple') {
      options.fields.ribMode = capitalizeFirstLetter(snap.choices.ribs.selected.mode)

      snap.choices.ribs.selected.rib.map((rib, index) => {
        if (index < snap.initialChoices.ribLimit) {
          options.fields[`ribColor${index + 1}`] = capitalizeFirstLetter(rib.name)
        }
      })
    }

    if (snap.choices.sealant.selected.mode === 'sealant') {
      options.fields.waterproofSealant = 'Yes'
    }
    if (snap.choices.raceNumber.selected.mode === 'number') {
      options.fields.raceNumber = snap.choices.raceNumber.selected.number
      options.fields.raceNumberColor = snap.choices.raceNumber.selected.name
      options.fields.raceNumberOutline = snap.choices.raceNumber.selected.outlineName
    }
    if (snap.uploadedFile?.image) {
      options.fields.uploadedImage = await blobUrlToDataURI(
        state.current.uploadedFile.image,
      )
      options.fields.imageName = state.current.uploadedFile.name
    }

    if (snap.choices.superBadge?.selected?.mode === 'badge') {
      if (snap.choices.superBadge.selected.subMode === 'number') {
        options.fields.badgeType = "Race Number on Badge"
        options.fields.badgeNumber = snap.choices.superBadge.selected.number
        options.fields.numFont = snap.choices.superBadge.selected.numFont
      }
      if (snap.choices.superBadge.selected.subMode === 'name') {
        options.fields.badgeType = "Rider Name on Badge"
        options.fields.badgeName = snap.choices.superBadge.selected.riderName
        options.fields.nameFont = snap.choices.superBadge.selected.nameFont
      }
    }

    // {snap.choices.superBadge.selected.subMode === "number" && <SummaryLine title="Badge Number" data={capitalizeFirstLetter(snap.choices.superBadge.selected.number)} />}
    // {snap.choices.superBadge.selected.subMode === "name" && <SummaryLine title="Rider Name" data={capitalizeFirstLetter(snap.choices.superBadge.selected.riderName)} />}
    // {snap.choices.superBadge.selected.subMode === "name" && <SummaryLine title="Font" data={capitalizeFirstLetter(snap.choices.superBadge.selected.nameFont)} />}
    // {snap.choices.superBadge.selected.subMode === "number" && <SummaryLine title="Font" data={capitalizeFirstLetter(snap.choices.superBadge.selected.numFont)} />}
    // {snap.choices.superBadge.selected.subMode === "name" || snap.choices.superBadge.selected.subMode === "number" ? <SummaryLine title="Font Color" data={capitalizeFirstLetter(snap.choices.superBadge.selected.name)} /> : null}
    // {snap.choices.superBadge.selected.subMode === "image" && <SummaryLine title="Logo" data={capitalizeFirstLetter("Uploaded Image")} />}
    // {snap.choices.superBadge.selected.subMode === "image" && <SummaryLine title="Logo Name" data={capitalizeFirstLetter(snap.uploadedFile.name)} />}

    console.log(productId, JSON.stringify(options))
    addToCart(productId, options)
  }

  return (
    <Button
      id="custom-add-to-cart"
      isDisabled={!snap.status.termsChecked | !snap.status.terms2Checked}
      accent
      handleClick={() => customAddToCart()}
    >
      Add to Cart
    </Button>
  )
}

export default PlaceOrderButton
